var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middle-wrapper"},[_c('div',{staticClass:"like-wrapper"},[_c('a',{ref:"likeBtn",staticClass:"like-button",on:{"click":_vm.like}},[_c('span',{ref:"likeIcon",staticClass:"like-icon"},[_c('div',{staticClass:"heart-animation-1"}),_c('div',{staticClass:"heart-animation-2"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }